export const newCreate_en = {

"Creating_walk_top" : "Create a walk",
"FAQ_banner_top" : "How does it work and other common questions",
"FAQ_question1" : "How does it work?",
"FAQ_question1_1" : "Choose the type of walk you want to create, don't worry - you can change it at the last step if something goes wrong",
"FAQ_question1_2" : "Follow the steps and fill in the walk's information",
"FAQ_question1_3" : "Create and post the walk",
"FAQ_question1_4" : "The walk is now available until it is booked in the network you have chosen.",
"FAQ_question1_5" : "If the walk is booked, you chat and decide the details",
"FAQ_question1_6" : "Meet on a walk!",

"FAQ_question2" : "Who will I walk with?",
"FAQ_question2_answer" : "The walk will be available and free to book for everyone in the network you posted the walk on, unless it is private. You as the creator always have control to decide whether the walk will happen or not. Cancel the walk if it doesn't suit, then the walk will be free for others to book again",

"FAQ_question3" : "My walk is booked, what should I do?",
"FAQ_question3_answer" : "Chat with the participant and see if you agree on the details. Always meet and walk in a public place. If you cannot participate for any reason, remember to cancel the walk and notify your walking partner.",

"FAQ_question4" : "My walk did not get booked",
"FAQ_question4_answer" : "Don't feel defeated, It happens. You can try editing the walk and changing the time, or share it yourself on other social media platforms to increase your chances. You can also post several walks at different times",

"FAQ_question5" : "I won’t be able to walk at the time I set",
"FAQ_question5_answer" : "Remember to notify your walking partner and cancel the walk. You can also talk in the chat and see if it is possible to rebook to another time. If so, then edit the walk with the new time",

"FAQ_question6" : "I want to chat with the person before I book a walk",
"FAQ_question6_answer" : "A chat opens when the walk is booked, then you can chat with the person. If you decide not to walk together, just cancel the walk. Otherwise you can send a friend request and if it is accepted you can also chat with the person.",

"FAQ_question7" : "Where do we meet?",
"FAQ_question7_answer" : "The meeting place is placed on the map, where you can also describe the place in more detail, e.g. 'by the red door': Make sure that you always meet and walk in a public place and make sure to be available in the chat when the walk is approaching. If you have difficulty finding each other, you can add an audio room in the walks page in the app and talk there until you find each other.",

"FAQ_question8" : "I want to walk in a group, how do I do that?",
"FAQ_question8_answer" : "It is very easy to do so! To post a group walk which can only be booked by up to 8 people, you need to be a Walking Talking Pro member",

"FAQ_question9" : "How do i invite a specific person to a walk?",
"FAQ_question9_answers" : "To invite a specific person in the app, you need to be a walking talking pro member. As a member you can walking suggestions directly in a chat with someone or in someone’s profile",

"OpenNetwork_button" : "The Public network",
"OpenNetwork_description" : "Walks in the public network are available to everyone in the app - You always control who you want to walk with.",

"AudioWalk_Description" : "Walk together but in different locations or find each other more easily when you arrive, by meeting in a private audio room in the app. No phone numbers need to be exchanged.",

"Network_Button" : "Network",
"Network_Description" : "Choose in which of your private or public networks you want to post a walk",

"Group_button" : "Group",
"Group_description" : "Create a walk that more than one person can book and go together as a group",

"Invite_button" : "Invitation",
"Invite_description" : "Choose who in your network you would like to send a walk suggestion too.",

"Private_button" : "Private",
"Private_Description" : "A private walk is only visible to you - You must actively share the walk in or outside the app for it to be booked",

"Profilebutton_button" : "Profile",
"Profilebutton_description" : "Post walks that are only visible to others who are actively viewing your profile calendar",

"Repeat_description" : "Create several of the same walk, make a walking plan or quickly and easily show your availability with several walks at once",

"starting_of_walk" : "Walk starts",
"date_of_walk" : "Date",
"StartingTime_of_walk" : "Starting time",
"length_of_walk" : "Length of walk",
"Walktime_preview" : "Preview the time",
"StartLength_walk" : "Start",
"EndLength_walk" : "Ending",
"ContinueNext_page" : "Select and continue",
"ContinueCancel_page" : "Cancel",

"HowCarry_walk" : "How do you want to carry out your walk?",
"Meet_In_person" : "I want to meet in person",
"Meet_in_person_description" : "You meet the person at a specified location and walk together",
"Remote_walk" : "I want to walk remotely",
"BookedPerson_choice" : "It’s up to the person that booked the walk.",
 "Choose_button" : "Choose",

"Map_spot_pick" : "Choose the meeting place by placing a point on the map or use the search function below",
"Search_field" : "Search",
"Add_description_location" : "Add a description of the location",
"Describe_location" : "Describe the location (optional)",
"Select_locationContinue" : "Select and continue",

"added_to_network" : "Posted in the network",
"ButtonCreateTop" : "Create",
"Part4_OpenNetwork" : "Open Network",
"When_walk" : "When",
"Control_StartTime" : "Check your starting time",
"How_walk" : "How",
"AddWalk_description" : "Add description",
"Pro_features" : "Pro features",
"Walking_repeat" : "Repeat",
"Walking_DontRepeat" : "Don’t repeat",
"Walk_invite" : "Invite",
"walk_choose_person" : "Choose person",
"Walk_available_spots" : "Available spots",
"Walk_privateWalk" : "Private Walk",
"Walk_onlyIn_profile" : "Only in my profile",
"Walk_createWalk" : "Create the walk",
"Walk_cancelWalk" : "Cancel",

"Visible_network" : "Choose in which network you want your walk to be visible and bookable",
"Visible_network_Public" : "Public networks",
"Visible_network_Open" : "The open network",
"Visible_network_my" : "My networks",
"Visible_publicButton" : "Public",

"Error_control_walk" : "Check your walk",

"Your_walk_created" : "Your walk has been created, view your walk:",
"Your_walk_created_multiple" : "Your walks have been created",
"Go_to_walk_option" : "Go to your walk",
"Go_to_page_option" : "Go to your page",


"Upgrade_account" : "Upgrade your account",
"Upgrade_account_Info" : "To access this feature, you must upgrade your account to Pro",
"Upgrade_leave_page" : "Leave and read more about pro",

"creatingwalkfp_choice" : "Choose a walk type to get started",
"cancel_errormessage_title" : "Cancel",
"cancel_errormessage_header" : "Are you sure you want to cancel?",
"cancel_errormessage_text" : "If you cancel you will lose your current progress",

"tipsandinfo_top" : "Tips and info",
"tipsandinfo_infotext" : "If you choose to meet on site, you can pick a spot on the map where you want to meet for you walk. If you choose to walk remotely, a chat room is created in the app. If it is up the the person booking the walk, you have to decide in the chat how you will meet.",
"tipsandinfo_tankpa" : "Things to consider:",
"tipsandinfo_iflocation" : "If you’re meeting at a location, always walk in a public place.",
"tipsandinfo_ifdistance" : "If you’re doing an audio walk, you don’t need to exchange phone numbers since you can talk in the app.",
"tipsandinfo_decide" : "It is always your choice who you walk and talk to.",
"tipsandinfo_contact" : "Always contact the person that booked the walk if you for some reason have to cancel the walk.",
"availablespots" : "Pick the amount of available spots for your walk",
"remotewalk_info" : "You and the participants walk in different separate locations while using an audio room in the app",
"upto_person_info" : "You decide together what works best",
"part5_meetingspot" : "Meeting spot:",
"topunder_search" : "None",
"upperselectionfarright" : "Friends list",

"frequency_choice" : "Decide how often you want to repeat your walk",
"frequency_amount" : "How often",
"frequency_choice1" : "Custom",
"frequency_choice2" : "Daily",
"frequency_choice3" : "Every week on the day",
"frequency_choice4" : "Every month on the day",
"frequency_choice5" : "Every day monday through friday",
"starttimeofwalk" : "Starting time",
"starttimeofwalk_howlong" : "Length",
"set_frequency_repetition" : "Set how you want the walk to repeat",


"mappopup_description" : "Place a mark on the map, start by tapping the map or by searching for the location you want to meet in the field above.",
"mapselectioncard_meet" : "Meeting spot",
"mapselectioncard_description" : "Describe the spot",
"mapselectioncard_detail" : "For example 'by the cafe' ,'The red door' etc",

"continuetonextpage" : "Save and continue",

"placeMapPin": 'Place the map pin where you wish to meet up.',
"setNumberOf": 'Set number',
"where_create": 'Where',

"error_title_length": 'The title needs to be longer than 3 characters',
"error_set_meeting" : 'You must set how you wish to meet',
'enter_description' : 'Enter description',
"read_more_here" : "Read more here",
"walk_is_repeated" : "Walk is repetead",

}